<style></style>

<template>
    <div class="row pt-3">
        <div class="col-sm-6 instruction pl-4 pt-4">
            <slot name="step"></slot>
        </div>
        <div class="col-sm-6 pt-4 status">
            <slot name="action"></slot>
        </div>
    </div>
</template>